import { ApolloProvider } from '@apollo/client';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { PushNotificationSetup } from './components/common/PushNotification/pushNotificationSetup.tsx';
import { Toaster } from './components/ui/sonner.tsx';
import './index.css';
import client from './providers/apolloConfig.ts';
import { registerServiceWorker } from './providers/serviceWorker.ts';

registerServiceWorker();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <ApolloProvider client={client}>
      <PushNotificationSetup />
      <App />
      <Toaster duration={2000} position='top-right' richColors closeButton />
    </ApolloProvider>
  </BrowserRouter>,
);
